<div class="navigation">
  <button *ngFor="let item of sections" (click)="scrollToElement(item.ref)">{{item.name}}</button>
</div>